import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Stack,
  Typography,
} from '@mui/material';
import { isResponseAPI, ResponseAPI, ResponseJSON, uploadArquivo } from 'api';
import { PermissionsI } from 'api/common.types';
import { getGroupsDropdown } from 'api/group/group.api';
import { getMunicipalitiesDropdown } from 'api/municipalities/municipalities.api';
import {
  // getPermission,
  getPermissionsDropdown,
} from 'api/permission/permission.api';
import { getProfilesDropdown } from 'api/profile/profile.api';
import { PartialUpdateUserData } from 'api/user/api.types';
import {
  createFirstUser,
  getListUsersByFilters,
  getUserVigencias,
  partialUpdateUser
} from 'api/user/user.api';
import ContainerPainel from 'components/container_painel';
import InputDados from 'components/input_dados';
import { DynamicDialog, ErrorDialog } from 'components/shared';
import { ContainerForm } from 'components/shared/container_form';
import { SnackbarFeedback } from 'components/shared/snackbar_feedback';
import AttachFileForm, { ArquivoData } from 'components/user/attach_file_form';
import LoginDataDisplay from 'components/user/login_data_display';
import LoginDataForm from 'components/user/login_data_form';
import PersonalDataDisplay from 'components/user/personal_data_display';
import PersonalDataForm from 'components/user/personal_data_form';
import RegistrationDataDisplay from 'components/user/registration_data_display';
import RegistrationDataForm from 'components/user/registration_dataForm';
import UserFormSteps from 'components/user/user_form_steps';
import { useAuth } from 'contexts/auth/auth_context';
import { tratarPermissoesUsuarioCreate as tratarPermissoesUsuario } from './user_form_create.helpers';
import {
  construirUserDataCreatePure as _construirUserDataCreatePure,
  validarDadosCreatePure as _validarDadosCreatePure,
  processarArquivoCreateHelper as _processarArquivoCreateHelper,
  gerarDadosAtualizadosCreatePure as _gerarDadosAtualizadosCreatePure,
  verificarAlteracaoDeVigenciaPure as _verificarAlteracaoDeVigenciaPure,
  getNameByUuidCreate as _getNameByUuidCreate,
  getTipoRepresentanteCreate as _getTipoRepresentanteCreate,
} from './user_form_create.helpers';
import { Formik, FormikHelpers } from 'formik';
import { isArray } from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ROUTES } from 'routes/constants';
import { getURLMTLogout } from 'services/auth/config';
import { formatCPF } from 'services/utils/format_cpf';
import { MENSAGENS, parseDate, validarData, verificarDatas } from 'utils/uteis';
import { cpfValidation } from 'utils/yup_cpf_validation';
import * as Yup from 'yup';
import RegisteredIcon from '../../assets/icons/registered-icon.svg';
import UpdatedIcon from '../../assets/icons/updated-icon.svg';


export enum UserFormAction {
  CADASTRAR = 'CADASTRAR',
  EDITAR = 'EDITAR',
}

interface UserDetailsData {
  personalData: {
    uuid: string;
    name: string;
    cpf: string;
    email: string;
    phone: string;
    uuidPhone?: string;
    position: string;
    occupation?: string; // Campo legado - opcional
    municipalityUuid: string;
    municipalities: string;
  };
  loginData: {
    groupUuid: string;
    profileUuid: string;
    permissionUuid: string;
    institutionUuid: string;
  };
  registrationData: {
    activeRegistration: boolean;
    blockRegistration: boolean;
  };
  dadosVigencia?: {
    vigenciaIndeterminada: boolean;
    dataInicial: string;
    dataFinal: string;
    isActive: boolean;
  };
  anexo: {
    uuid: string;
    name: string;
  };
}

const UserFormCreate: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const pathParts = location.pathname.split('/');
  const action = pathParts[2];
  const userUuid = pathParts[3];
  const { user } = useAuth();
  const PRIMEIRO_ACESSO = !user;



  const [userFormAction, setUserFormAction] = useState<UserFormAction | null>(
    null,
  );
  const [activeStep, setActiveStep] = useState(1);
  const [municipalitiesDropdown, setMunicipalitiesDropdown] = useState<
    { name: string }[]
  >([]);
  const [loadingMunicipalities, setLoadingMunicipalities] =
    useState<boolean>(false);
  const [groupsDropdown, setGroupsDropdown] = useState<PermissionsI>({
    data: [],
  });
  const [profilesDropdown, setProfilesDropdown] = useState<PermissionsI>({
    data: [],
  });
  const [permissionsDropdown, setPermissionsDropdown] = useState<PermissionsI>({
    data: [],
  });
  const [institutionDropdown] = useState<PermissionsI>({
    data: [],
  });
  const [userDetails, setUserDetails] = useState<UserDetailsData | null>(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [invalidRequest, setInvalidRequest] = useState(false);
  const [duplicateError, setDuplicateError] = useState<string | null>(null);
  const [
    permissionMandatoryValidityValidation
  ] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>();
  const [arquivoAnexo, setArquivoAnexo] = useState<ArquivoData>();
  const [previewUrl, setPreviewUrl] = useState<string | undefined>();

  const cpfRef = useRef<HTMLInputElement>(null);
  const emailRef = useRef<HTMLInputElement>(null);

  const [permissaoSelelcionadaNome, setpermissaoSelelcionadaNome] =
    useState<string>();

  const [dataVigenciaInicial, setdataVigenciaInicial] = useState<string>('');
  const [dataVigenciaFinal, setdataVigenciaFinal] = useState<string>('');
  const [dataVigenciaIndeterminada, setdataVigenciaIndeterminada] =
    useState<boolean>(false);

  const [primeiroAcessoInstituicao, setPrimeiroAcessoInstituicao] =
    useState<Record<string, any>>();
  const [primeiroAcessoProfile, setPrimeiroAcessoProfile] =
    useState<string>('');

  useEffect(() => {
    if (PRIMEIRO_ACESSO) {
      handlePrimeiroAcesso();
    }
    const fetchMunicipalities = async () => {
      setLoadingMunicipalities(true);

      try {
        const data = await getMunicipalitiesDropdown();
        setMunicipalitiesDropdown(data?.data);
      } catch (error) {
        console.error('Error ao buscar municipios:', error);
      } finally {
        setLoadingMunicipalities(false);
      }
    };

    fetchMunicipalities();
  }, []);

  const handlePrimeiroAcesso = () => {
    const DadosPrimeiroAcessoJSON = localStorage.getItem('firstRegisterData');
    const DadosPrimeiroAcesso = JSON.parse(DadosPrimeiroAcessoJSON || '{}');

    setPrimeiroAcessoInstituicao(DadosPrimeiroAcesso.institution);
    setPrimeiroAcessoProfile(DadosPrimeiroAcesso.selectedProfile);

  };

  const handleGroupChange = async (groupUuid: string) => {
    if (!groupUuid) {
      setProfilesDropdown({ data: [] });
      setPermissionsDropdown({ data: [] });
      return;
    }

    try {
      const profiles = await getProfilesDropdown(groupUuid);
      setProfilesDropdown(profiles);
      setPermissionsDropdown({ data: [] });
      // O LoginDataForm gerenciará a mudança automática do perfil via useEffect
    } catch (error) {
      console.error('Erro ao buscar perfis:', error);
    }
  };

  const handleProfileChange = async (profileUuid: string) => {
    if (!profileUuid) {
      setPermissionsDropdown({ data: [] });
      return;
    }

    try {
      const permissions = await getPermissionsDropdown(profileUuid);
      const permissoesAjustadas = tratarPermissoesUsuario(
        permissions,
        profileUuid,
        profilesDropdown,
      );
      setPermissionsDropdown(permissoesAjustadas);
    } catch (error) {
      console.error('Erro ao buscar permissões:', error);
    }
  };

  // uses tratarPermissoesUsuario from helpers

  const handlePermissionChange = async (permissionUuid: string) => {
    if (permissionUuid) {
      try {
        // const permissionData = await getPermission(permissionUuid);
        // setPermissionMandatoryValidityValidation(
        //   permissionData.mandatoryValidityValidation,
        // );
      } catch (error) {
        console.error('Erro ao buscar permissões:', error);
      }
    }
  };

  useEffect(() => {
    const fetchDropdowns = async () => {
      const profiles = await getProfilesDropdown();
      setProfilesDropdown(profiles);

      const permissions = await getPermissionsDropdown();
      setPermissionsDropdown(permissions);

      const groups = await getGroupsDropdown();
      setGroupsDropdown(groups);

      return { profiles, permissions, groups };
    };

    const fetchUserDetails = async (uuid: string) => {
      const dropDowns = await fetchDropdowns();
      const { profiles, permissions } = dropDowns;

      try {
        const Resp = await getListUsersByFilters({
          limit: '10',
          uuid: uuid,
        });

        if (isResponseAPI(Resp)) {
          const RespAux: ResponseAPI = Resp;
          alert(RespAux.Mensagem);

          setInvalidRequest(true);
        } else {
          const userDetailsData: ResponseJSON = Resp;
          const UserAux = userDetailsData?.data[0] ?? {};

          const profileUuidAux = UserAux.permission?.profile?.uuid;
          const permissaoID = UserAux.permission?.uuid;

          if (profileUuidAux) {
            const permissoesAjustadas = tratarPermissoesUsuario(
              permissions,
              profileUuidAux,
              profiles,
            );
            setPermissionsDropdown(permissoesAjustadas);
          }

          let permissaoNome;
          if (permissions && permissaoID) {
            permissaoNome = permissions.data.find(
              (item: { uuid: any }) => item.uuid === permissaoID,
            )?.name;

            setpermissaoSelelcionadaNome(permissaoNome);
          }

          let dadosVigencia = null;

          if (getTipoRepresentanteMunicipal(permissaoNome)) {
            dadosVigencia = await getUserVigencias(uuid);
            dadosVigencia = dadosVigencia?.data;
            if (dadosVigencia && isArray(dadosVigencia)) {
              dadosVigencia = dadosVigencia[0];
            }
          }

          setUserDetails({
            personalData: {
              uuid,
              name: UserAux.name,
              cpf: formatCPF(UserAux.identification),
              email: UserAux.email,
              phone: UserAux.contactList[0]?.value,
              position: UserAux.position,
              municipalityUuid: UserAux.address?.municipality,
              municipalities: UserAux.address?.municipality,
            },
            loginData: {
              groupUuid: UserAux.permission?.profile?.group?.uuid,
              profileUuid: UserAux.permission?.profile?.uuid,
              permissionUuid: UserAux.permission?.uuid,
              institutionUuid: UserAux.institutionUuid,
            },
            registrationData: {
              activeRegistration: UserAux.isRegisterActive,
              blockRegistration: UserAux.isRegisterBlocked,
            },
            anexo: {
              uuid: UserAux.uuid,
              name: UserAux.name,
            },
          });

          if (dadosVigencia) {
            const convertInitialDate = dadosVigencia.dataInicial.split('-');
            const convertFinalDate = dadosVigencia.dataFinal.split('-');
            const initialDate = `${convertInitialDate[2]}/${convertInitialDate[1]}/${convertInitialDate[0]}`;
            const finalDate = `${convertFinalDate[2]}/${convertFinalDate[1]}/${convertFinalDate[0]}`;
            setdataVigenciaInicial(initialDate);
            setdataVigenciaFinal(finalDate);
            setdataVigenciaIndeterminada(
              !dadosVigencia.dataFinal
                ? true
                : dadosVigencia.vigenciaIndeterminada,
            );
          }
        }
      } catch (error) {
        alert(error);
        setInvalidRequest(true);
      }
    };

    if (action === 'cadastrar') {
      const initializeCadastrar = async () => {
        const { groups } = await fetchDropdowns();

        // Re-fetch profiles filtered by the default MUNICIPAL group and load
        // the correct permissions for PREFEITURA MUNICIPAL. This mirrors what
        // happens on a manual group change, ensuring the dropdowns are properly
        // filtered from the very first render.
        const municipalGroup = groups?.data?.find(
          (g: any) => g.name?.toUpperCase() === 'MUNICIPAL',
        );
        if (municipalGroup?.uuid) {
          const filteredProfiles = await getProfilesDropdown(municipalGroup.uuid);
          setProfilesDropdown(filteredProfiles);

          const prefeituraMunicipalProfile = filteredProfiles?.data?.find(
            (p: any) => p.name?.toUpperCase().includes('PREFEITURA MUNICIPAL'),
          );
          if (prefeituraMunicipalProfile?.uuid) {
            const permissions = await getPermissionsDropdown(
              prefeituraMunicipalProfile.uuid,
            );
            const permissoesAjustadas = tratarPermissoesUsuario(
              permissions,
              prefeituraMunicipalProfile.uuid,
              filteredProfiles,
            );
            setPermissionsDropdown(permissoesAjustadas);
          }
        }
      };

      initializeCadastrar();
      setUserFormAction(UserFormAction.CADASTRAR);
    } else if (action === 'editar' && userUuid) {
      setUserFormAction(UserFormAction.EDITAR);
      fetchUserDetails(userUuid);
    }
  }, [action, location.pathname, userFormAction, userUuid]);


  useEffect(() => {
    const f = arquivoAnexo?.arquivoSelecionado;
    if (f) {
      const url = URL.createObjectURL(f);
      setPreviewUrl(url);
      return () => URL.revokeObjectURL(url);
    }
    setPreviewUrl(undefined);
  }, [arquivoAnexo?.arquivoSelecionado]);

  const initialValues = {
    personalData: {
      name: userDetails?.personalData?.name ?? '',
      cpf: userDetails?.personalData?.cpf ?? '',
      email: userDetails?.personalData?.email ?? '',
      phone: userDetails?.personalData?.phone ?? '',
      position: userDetails?.personalData?.position ?? '',
      // campo occupation REMOVIDO - não existe mais no formulário
      municipality:
        primeiroAcessoInstituicao?.address?.municipality ??
        userDetails?.personalData?.municipalityUuid ??
        '',
      municipalities:
        primeiroAcessoInstituicao?.address?.municipality ??
        userDetails?.personalData?.municipalities ??
        '',
    },
    loginData: {
      group: userDetails?.loginData?.groupUuid ?? '',
      profile: userDetails?.loginData?.profileUuid ?? '',
      permission: userDetails?.loginData?.permissionUuid ?? '',
    },
    registrationData: {
      activeRegistration:
        userDetails?.registrationData?.activeRegistration === true,
      blockRegistration:
        userDetails?.registrationData?.blockRegistration === true,
    },
    anexo: {
      uuid: userDetails?.anexo.uuid,
      name: userDetails?.anexo.name,
    },
  };

  const validationSchema = Yup.object().shape({
    personalData: Yup.object().shape({
      name: Yup.string().required(
        'Preencha esse campo corretamente, com um dado válido.',
      ),
      cpf: cpfValidation('Preencha esse campo corretamente, com um dado válido.'),
      email: Yup.string()
        .email('Preencha esse campo corretamente, com um dado válido.')
        .required('Preencha esse campo corretamente, com um dado válido.'),
      phone: Yup.string().required(
        'Preencha esse campo corretamente, com um dado válido.',
      ),
      position: Yup.string().required(
        'Preencha esse campo corretamente, com um dado válido.',
      ),
      // occupation removido - campo legado que não existe mais no formulário
    }),
    loginData: Yup.object().shape({
      group: Yup.string().required(
        'Preencha esse campo corretamente, com um dado válido.',
      ),
      profile: Yup.string().required(
        'Preencha esse campo corretamente, com um dado válido.',
      ),
      permission: Yup.string().required(
        'Preencha esse campo corretamente, com um dado válido.',
      ),
    }),
    registrationData: PRIMEIRO_ACESSO
      ? Yup.object().shape({
        activeRegistration: Yup.boolean().notRequired(),
        blockRegistration: Yup.boolean().notRequired(),
      })
      : Yup.object().shape({
        activeRegistration: Yup.boolean().required(
          'Selecione se o cadastro está ativo.',
        ),
        blockRegistration: Yup.boolean().required(
          'Selecione se deseja bloquear o cadastro.',
        ),
      }),
  });

  const handleEditClick = () => {
    setActiveStep(1);
  };

  const clearDuplicateError = () => {
    setDuplicateError(null);
  };

  const handleSubmit = async (
    values: typeof initialValues,
    actions: FormikHelpers<typeof initialValues>,
  ) => {
    console.log('🔵 handleSubmit chamado', {
      activeStep,
      values,
      permissaoSelelcionadaNome,
      getTipoRepresentanteMunicipal: getTipoRepresentanteMunicipal()
    });

    if (!validarDados()) {
      console.log('❌ validarDados retornou false');
      actions.setSubmitting(false);
      return;
    }

    console.log('✅ validarDados passou, avançando step');

    if (activeStep === 1) {
      console.log('🔄 Avançando do step 1 para step 2');
      setActiveStep(2);
      actions.setSubmitting(false);
      return;
    }

    if (activeStep === 2) {
      try {
        const arquivoAnexoSubmetido = await processarArquivoAnexo();
        const userData = construirUserData(values, arquivoAnexoSubmetido);

        if (userFormAction === UserFormAction.CADASTRAR) {
          await cadastrarUsuario(userData);
        } else if (userFormAction === UserFormAction.EDITAR) {
          await editarUsuario(values, userData);
        } else {
          alert('Erro ao tentar criar ou alterar o usuário.');
        }
      } catch (error) {
        console.error('Erro ao tentar criar ou alterar o usuário.', error);
        setErrorMessage('Erro ao tentar criar ou alterar o usuário.');
      } finally {
        actions.setSubmitting(false);
      }
    }
  };

  const processarArquivoAnexo = async (): Promise<ResponseJSON | null> => {
    if (!arquivoAnexo) return null;
    const Resp = await uploadArquivo({
      ...arquivoAnexo,
      type: 'COMPROVANTE DE REPRESENTANTE LEGAL MUNICIPAL',
    });

    if (Resp.Status === 'OK') {
      return Resp.dados as ResponseJSON;
    } else {
      alert(Resp.Mensagem);
      return null;
    }
  };

  const construirUserData = (values: any, arquivoUuid: any) => {
    let userData = {
      name: values.personalData.name,
      identification: values.personalData.cpf,
      email: values.personalData.email,
      contactList: [
        {
          type: 'CELULAR',
          value: '+55' + values.personalData.phone.replace(/\D/g, ''),
        },
      ],
      position: values.personalData.position,
      groupUuid: values.loginData.group,
      profileUuid: values.loginData.profile,
      permissionUuid: values.loginData.permission,
      representativeFileUuid: arquivoUuid?.uuid,
      isRegisterActive: values.registrationData.activeRegistration,
      isRegisterBlocked: values.registrationData.blockRegistration,
      hasAcceptedConfidentialityTerm: false,
      hasAcceptedTermOfUse: false,
      address: {
        municipality: values.personalData.municipalities,
      },
      institutionUuid: null,
      dadosVigencia: getTipoRepresentanteMunicipal()
        ? {
          vigenciaIndeterminada: dataVigenciaIndeterminada,
          dataInicial: parseDate(dataVigenciaInicial),
          dataFinal: dataVigenciaFinal ? parseDate(dataVigenciaFinal) : null,
          isActive: true,
          representativeFileUuid: arquivoUuid?.uuid,
        }
        : null,
    };

    if (PRIMEIRO_ACESSO) {
      userData = {
        ...userData,
        isRegisterActive: false,
        isRegisterBlocked: false,
        hasAcceptedTermOfUse: true,
        hasAcceptedConfidentialityTerm: true,
        institutionUuid: primeiroAcessoInstituicao?.uuid,
      };
    }

    return userData;
  };

  const cadastrarUsuario = async (userData: any) => {
    const response = await createFirstUser(userData);

    if (response.Status === 'OK') {
      setIsDialogOpen(true);
      return;
    }

    const newResponse = await createFirstUser({
      ...userData,
      institutionUuid: null,
    });
    if (newResponse.Status === 'OK') {
      setIsDialogOpen(true);
    } else {
      alert(newResponse.Mensagem);
    }
  };

  const editarUsuario = async (values: any, userData: any) => {
    if (!userDetails?.personalData.uuid) return;

    const partialUpdateUserData = gerarDadosAtualizados(values);
    const alterouVigencia = verificarAlteracaoDeVigencia();



    if (alterouVigencia) {
      const confirmation = confirm(
        'Você está alterando a sua vigência. Caso continue será deslogado, e será exigido aprovação por Responsável. Deseja continuar?',
      );
      if (!confirmation) return;
    }

    const response = await partialUpdateUser(
      userDetails?.personalData.uuid,
      partialUpdateUserData,
    );

    if (response?.Status === 'OK') {
      setIsDialogOpen(true);
      if (alterouVigencia) {
        window.location.href = getURLMTLogout();
      } else {
        alert(response.Mensagem);
      }
    }
  };

  const hasChanged = (original: any, updated: any) => {
    return JSON.stringify(original) !== JSON.stringify(updated);
  };

  const gerarDadosAtualizados = (values: any) => {
    const updatedData: Partial<PartialUpdateUserData> = {};

    if (getTipoRepresentanteMunicipal()) {
      updatedData.dadosVigencia = {
        vigenciaIndeterminada: dataVigenciaIndeterminada,
        dataInicial: parseDate(dataVigenciaInicial),
        dataFinal: dataVigenciaFinal ? parseDate(dataVigenciaFinal) : null,
        isActive: true,
      };
    }

    if (
      hasChanged(userDetails?.personalData.email, values.personalData.email)
    ) {
      updatedData.email = values.personalData.email;
    }

    if (
      hasChanged(userDetails?.personalData.phone, values.personalData.phone)
    ) {
      updatedData.contactList = [
        {
          uuid: userDetails?.personalData.uuidPhone,
          type: 'CELULAR',
          value: values.personalData.phone,
        },
      ];
    }

    if (
      hasChanged(userDetails?.personalData?.position, values.personalData.position)
    ) {
      updatedData.position = values.personalData.position;
    }


    if (
      hasChanged(
        userDetails?.personalData.position,
        values.personalData.position,
      )
    ) {
      updatedData.position = values.personalData.position;
    }


    if (
      hasChanged(userDetails?.loginData.profileUuid, values.loginData.profile)
    ) {
      updatedData.profileUuid = values.loginData.profile;
    }

    if (hasChanged(userDetails?.loginData.groupUuid, values.loginData.group)) {
      updatedData.groupUuid = values.loginData.group;
    }


    if (
      hasChanged(
        userDetails?.loginData.permissionUuid,
        values.loginData.permission,
      )
    ) {
      updatedData.permissionUuid = values.loginData.permission;
    }

    updatedData.isRegisterActive = values.registrationData.activeRegistration;
    updatedData.isRegisterBlocked = values.registrationData.blockRegistration;
    updatedData.representativeFileUuid = values.anexo.uuid;

    return updatedData;
  };

  useEffect(() => {
    const salvo = JSON.parse(sessionStorage.getItem('arquivoAnexo') ?? 'null');
    if (salvo) {
      setArquivoAnexo(salvo);
    }
  }, []);



  const verificarAlteracaoDeVigencia = () => {
    if (
      userDetails?.personalData.uuid === user?.uuid &&
      getTipoRepresentanteMunicipal()
    ) {
      return (
        (!userDetails?.dadosVigencia?.dataInicial && dataVigenciaInicial) ||
        (!userDetails?.dadosVigencia?.dataFinal && dataVigenciaFinal) ||
        hasChanged(
          userDetails?.dadosVigencia?.vigenciaIndeterminada,
          dataVigenciaIndeterminada,
        ) ||
        hasChanged(
          userDetails?.dadosVigencia?.dataInicial,
          dataVigenciaInicial,
        ) ||
        hasChanged(userDetails?.dadosVigencia?.dataFinal, dataVigenciaFinal)
      );
    }
    return false;
  };

  const handleBack = () => {
    if (activeStep === 2) {
      setActiveStep(1);
    } else {
      navigate(ROUTES.FIRSTUSER);
    }
  };

  const handleRefresh = () => {
    window.location.reload();
    setInvalidRequest(false);
  };

  const getNameByUuid = (
    uuid: string,
    list: { data: { uuid: string; name: string }[] },
  ) => {
    if (!list || !list.data) return 'N/A';
    const item = list.data.find((entry) => entry.uuid === uuid);
    return item ? item.name : 'N/A';
  };

  const validarDados = (): boolean => {
    console.log('📋 validarDados chamado', {
      permissaoSelelcionadaNome,
      getTipoRepresentanteMunicipal: getTipoRepresentanteMunicipal(),
      dataVigenciaInicial,
      dataVigenciaFinal,
      dataVigenciaIndeterminada,
      arquivoAnexo: arquivoAnexo?.nomeArquivoOriginal,
      userFormAction,
      activeStep
    });

    const isTipoRepresentanteMunicipal = getTipoRepresentanteMunicipal();
    console.log('🔍 É representante municipal?', isTipoRepresentanteMunicipal);

    if (isTipoRepresentanteMunicipal) {
      if (!dataVigenciaInicial || dataVigenciaInicial.trim() == '') {
        const mensagem = `Data de Inicio ${MENSAGENS.PREENCHIMENTO_OBRIGATORIO}`;
        console.log('Erro validação:', mensagem);
        alert(mensagem);
        return false;
      }

      if (!validarData(dataVigenciaInicial)) {
        const mensagem = `Data de Início ${MENSAGENS.PREENCHIMENTO_INVALIDO}`;
        console.log('Erro validação:', mensagem);
        alert(mensagem);
        return false;
      }

      if (!dataVigenciaIndeterminada) {
        if (!dataVigenciaFinal || dataVigenciaFinal.trim() == '') {
          const mensagem = `Data Fim ${MENSAGENS.PREENCHIMENTO_OBRIGATORIO}`;
          console.log('Erro validação:', mensagem);
          alert(mensagem);
          return false;
        }

        if (!validarData(dataVigenciaFinal)) {
          const mensagem = `Data Fim ${MENSAGENS.PREENCHIMENTO_INVALIDO}`;
          console.log('Erro validação:', mensagem);
          alert(mensagem);
          return false;
        }

        if (!verificarDatas(dataVigenciaInicial, dataVigenciaFinal)) {
          const mensagem = 'A Data Final de Vigência deve ser posterior a Data Inicial. Verifique e selecione uma Data válida para continuar';
          console.log('Erro validação:', mensagem);
          alert(mensagem);
          return false;
        }
      }

      if (
        userFormAction === UserFormAction.CADASTRAR &&
        !(arquivoAnexo && arquivoAnexo.nomeArquivoOriginal?.length > 0)
      ) {
        const mensagem = 'Para Representante Municipal o Arquivo Anexo é obrigatório';
        console.log('❌ Erro validação:', mensagem);
        alert(mensagem);
        return false;
      }
    } else {
      console.log('ℹ️ Não é representante municipal, pulando validações específicas');
    }

    console.log('✅ validarDados passou todas as verificações');
    return true;
  };

  const getTipoRepresentanteMunicipal = (
    permissaoParm = permissaoSelelcionadaNome,
  ): boolean => {
    return (
      permissaoParm?.trim().toUpperCase() === 'REPRESENTANTE LEGAL MUNICIPAL' ||
      false
    );
  };

  let successMessage: string;

  if (userFormAction === UserFormAction.CADASTRAR) {
    if (PRIMEIRO_ACESSO) {
      successMessage =
        'CADASTRO FEITO COM SUCESSO, AGUARDANDO A APROVAÇÃO DO GERENTE ESTADUAL';
    } else {
      successMessage = 'O Usuário foi cadastrado com sucesso.';
    }
  } else {
    successMessage = 'O Usuário foi alterado com sucesso.';
  }

  return (
    <ContainerPainel
      pagina={
        user
          ? userFormAction === UserFormAction.CADASTRAR
            ? 'Cadastrar Usuário'
            : 'Editar Usuário'
          : 'Cadastro - Primeiro Acesso'
      }
      showBackButton={true}
    >
      <Box
        sx={{
          backgroundColor: '#FAFAFA',
        }}
      >
        <UserFormSteps activeStep={activeStep} />
        <Box
          sx={{
            height: '79px',
            gap: '24px',
          }}
        >
          <Typography variant='h5' sx={{ textAlign: 'center' }}>
            {activeStep === 1 ? 'Dados principais' : 'Confirmação dos dados'}
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Roboto',
              fontSize: '16px',
              letterSpacing: '0.17px',
              fontWeight: 400,
              lineHeight: '22.88px',
              marginTop: '20px',
              textAlign: 'center',

            }}
          >
            {activeStep === 1
              ? 'Informe corretamente os dados principais do usuário cadastrado.'
              : 'Confira todas as informações que foram preenchidas, e altere-as caso necessário.'}
          </Typography>
        </Box>

        {PRIMEIRO_ACESSO && (
          <>
            {primeiroAcessoProfile !== 'agricultor' && (
              <Box display={'flex'} justifyContent={'center'}>
                <ContainerForm title='Dados da Instituição' width='1152px'>
                  <Stack spacing={2}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <Typography variant='subtitle2' color='textSecondary'>
                          Nome Fantasia
                        </Typography>
                        <Typography variant='body1'>
                          {primeiroAcessoInstituicao?.fantasyName}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Typography variant='subtitle2' color='textSecondary'>
                          CNPJ
                        </Typography>
                        <Typography variant='body1'>
                          {primeiroAcessoInstituicao?.identification}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Typography variant='subtitle2' color='textSecondary'>
                          Razão Social
                        </Typography>
                        <Typography variant='body1'>
                          {primeiroAcessoInstituicao?.name}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Typography variant='subtitle2' color='textSecondary'>
                          Município
                        </Typography>
                        <Typography variant='body1'>
                          {primeiroAcessoInstituicao?.address?.municipality}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Stack>
                </ContainerForm>
              </Box>
            )}
          </>
        )}

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
          validateOnChange={true}
          validateOnBlur={true}
          validateOnMount={false}
          context={{ action }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            isSubmitting,
            isValid,
            isValidating,
          }) => {
            console.log('🔄 Formik render', {
              activeStep,
              isValid,
              isValidating,
              isSubmitting,
              errors,
              values: {
                personalData: values.personalData,
                loginData: values.loginData
              }
            });
            const toBool = (v: unknown) =>
              typeof v === 'string' ? Boolean(JSON.parse(v)) : Boolean(v);

            const rd = values.registrationData ?? {};
            const registrationDisplay = {
              activeRegistration: toBool(rd.activeRegistration) ? 'SIM' : 'NÃO',
              blockRegistration: toBool(rd.blockRegistration) ? 'SIM' : 'NÃO',
              termData: null,
            };

            return (
              <form
                onSubmit={(e) => {
                  console.log('📝 Form onSubmit event', {
                    activeStep,
                    isValid,
                    isSubmitting,
                    errors
                  });
                  handleSubmit(e);
                }}
              >
                <Box
                  sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    flexWrap: 'nowrap',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  {activeStep === 1 ? (
                    <>
                      <PersonalDataForm
                        municipalitiesOptions={municipalitiesDropdown}
                        loadingMunicipalities={loadingMunicipalities}
                        values={values}
                        errors={errors}
                        touched={touched}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        duplicateError={duplicateError}
                        fieldsRef={{ cpfRef, emailRef }}
                        clearDuplicateError={clearDuplicateError}
                        editMunicipality={true}
                        userFormAction={userFormAction ?? UserFormAction.CADASTRAR}
                        setFieldValue={setFieldValue}
                        primeiroAcessoInstituicao={primeiroAcessoInstituicao}
                        user={user}
                      />
                      <LoginDataForm
                        groupOptions={groupsDropdown}
                        profileOptions={profilesDropdown}
                        permissionOptions={permissionsDropdown}
                        institutionOptions={institutionDropdown}
                        values={values}
                        errors={errors}
                        touched={touched}
                        permissionViewPassword={true}
                        setFieldValue={setFieldValue}
                        handleChange={(e) => {
                          const { name, value } = e.target;

                          if (name === 'loginData.group') {
                            setFieldValue('loginData.group', value);
                            // Não limpar o perfil aqui - deixar LoginDataForm gerenciar via useEffect
                            setFieldValue('loginData.permission', '');
                            handleGroupChange(value).then(() => {
                              // After profiles are loaded, auto-select profile and load permissions
                              const selectedGroup = groupsDropdown?.data?.find(g => g.uuid === value);
                              const groupName = selectedGroup?.name?.toUpperCase() ?? '';
                              if (groupName.includes('ESTADUAL')) {
                                // The profile will be auto-set by LoginDataForm's useEffect,
                                // but we need to also trigger permission loading for it
                                getProfilesDropdown(value).then((profiles) => {
                                  const estadualProfile = profiles?.data?.find(
                                    (p: any) => p.name?.toUpperCase().includes('SECRETARIA DE ESTADO DE AGRICULTURA FAMILIAR')
                                  );
                                  if (estadualProfile) {
                                    handleProfileChange(estadualProfile.uuid);
                                  }
                                }).catch(() => { });
                              }
                            });
                          }

                          if (name === 'loginData.profile') {
                            setFieldValue('loginData.profile', value);
                            setFieldValue('loginData.permission', '');
                            handleProfileChange(value);
                          }

                          if (name === 'loginData.permission') {
                            setFieldValue('loginData.permission', value);
                            handlePermissionChange(value);
                            const PermissaoNome =
                              permissionsDropdown?.data?.find(
                                (item) => item.uuid === value,
                              )?.name;

                            setpermissaoSelelcionadaNome(PermissaoNome);
                          }

                          handleChange(e);
                        }}
                        handleBlur={handleBlur}
                        userFormAction={userFormAction ?? UserFormAction.CADASTRAR}
                      />
                      {!PRIMEIRO_ACESSO && (
                        <RegistrationDataForm
                          values={values}
                          errors={errors}
                          touched={touched}
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          userFormAction={userFormAction ?? UserFormAction.CADASTRAR}
                          permissionMandatoryValidityValidation={
                            permissionMandatoryValidityValidation
                          }
                        />
                      )}

                      {permissaoSelelcionadaNome &&
                        permissaoSelelcionadaNome.trim().toUpperCase() ===
                        'REPRESENTANTE LEGAL MUNICIPAL' && (
                          <ContainerForm
                            title='Dados da Vigência'
                            width='1150px'
                          >
                            <Grid container spacing={2}>
                              <Grid item xs={12} md={6}>
                                <InputDados
                                  placeholder='Data Inicial de Vigência'
                                  label='Data Inicial de Vigência'
                                  mask='99/99/9999'
                                  value={dataVigenciaInicial}
                                  onChange={(e: any) => {
                                    setdataVigenciaInicial(e.target.value);
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <InputDados
                                  placeholder='Data Final de Vigência'
                                  value={dataVigenciaFinal}
                                  label='Data Final de Vigência'
                                  mask='99/99/9999'
                                  onChange={(e: any) => {
                                    setdataVigenciaFinal(e.target.value);
                                  }}
                                  disabled={dataVigenciaIndeterminada}
                                />
                              </Grid>
                              <Grid item xs={12}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={dataVigenciaIndeterminada}
                                      onChange={(e) => {
                                        setdataVigenciaIndeterminada(
                                          e.target.checked,
                                        );
                                      }}
                                    />
                                  }
                                  label='Data final indeterminada'
                                />
                              </Grid>
                            </Grid>
                          </ContainerForm>
                        )}

                      {permissaoSelelcionadaNome &&
                        permissaoSelelcionadaNome.trim().toUpperCase() ===
                        'REPRESENTANTE LEGAL MUNICIPAL' && (
                          <AttachFileForm
                            arquivoData={arquivoAnexo}
                            setArquivoData={setArquivoAnexo}
                          />
                        )}
                    </>
                  ) : (
                    <>
                      <PersonalDataDisplay
                        values={{
                          ...values.personalData,
                        }}
                        onEditClick={handleEditClick}
                        isView={false}
                      />
                      <LoginDataDisplay
                        values={{
                          profile: getNameByUuid(
                            values.loginData.profile,
                            profilesDropdown,
                          ),
                          group: getNameByUuid(
                            values.loginData?.group,
                            groupsDropdown,
                          ),
                          permission: getNameByUuid(
                            values.loginData.permission,
                            permissionsDropdown,
                          ),
                        }}
                        onEditClick={handleEditClick}
                        isView={false}
                      />
                      <RegistrationDataDisplay
                        values={registrationDisplay}
                        onEditClick={handleEditClick}
                        isView={false}
                      />

                      {permissaoSelelcionadaNome &&
                        permissaoSelelcionadaNome.trim().toUpperCase() ===
                        'REPRESENTANTE LEGAL MUNICIPAL' && (
                          <ContainerForm
                            width='1150px'
                            title='Dados da Vigência'

                          >
                            <Grid container spacing={2}>
                              <Grid item xs={12} md={6}>
                                <InputDados
                                  placeholder='Data Inicial de Vigência'
                                  label='Data Inicial de Vigência'
                                  mask='99/99/9999'
                                  value={dataVigenciaInicial}
                                  onChange={(e: any) => {
                                    setdataVigenciaInicial(e.target.value);
                                  }}
                                  disabled
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <InputDados
                                  label='Data Final de Vigência'
                                  placeholder='Data Final de Vigência'
                                  mask='99/99/9999'
                                  value={dataVigenciaFinal}
                                  onChange={(e: any) => {
                                    setdataVigenciaFinal(e.target.value);
                                  }}
                                  disabled
                                />
                              </Grid>
                              <Grid item xs={12}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={dataVigenciaIndeterminada}
                                      onChange={(e) => {
                                        setdataVigenciaIndeterminada(
                                          e.target.checked,
                                        );
                                      }}
                                    />
                                  }
                                  label='Data final indeterminada'
                                  disabled
                                />
                              </Grid>
                            </Grid>
                            {arquivoAnexo ? (
                              <Box sx={{ p: 1 }}>
                                <Grid container spacing={2}>
                                  <Grid item xs={12} md={8}>
                                    <Typography sx={{ fontWeight: 500 }}>
                                      {arquivoAnexo.nomeArquivoOriginal || arquivoAnexo.nomeArquivo}
                                    </Typography>
                                    <Typography variant="body2">
                                      {(arquivoAnexo.arquivoSelecionado?.type ?? arquivoAnexo.type ?? arquivoAnexo.extensaoArquivo?.toUpperCase() ?? '—')}
                                      {(() => {
                                        const bytes = arquivoAnexo.arquivoSelecionado?.size ?? arquivoAnexo.size;
                                        return bytes ? ` • ${(bytes / 1024).toFixed(2)} KB` : '';
                                      })()}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={12} md={4}
                                    sx={{ display: 'flex', gap: 1, justifyContent: { xs: 'flex-start', md: 'flex-end' } }}>
                                    {previewUrl && (
                                      <>
                                        <Button variant="outlined" component="a" href={previewUrl} target="_blank" rel="noreferrer">
                                          Visualizar
                                        </Button>
                                        <Button
                                          variant="contained"
                                          component="a"
                                          href={previewUrl}
                                          download={arquivoAnexo.nomeArquivoOriginal || arquivoAnexo.nomeArquivo || 'anexo'}
                                        >
                                          Baixar
                                        </Button>
                                      </>
                                    )}
                                  </Grid>
                                </Grid>
                              </Box>
                            ) : (
                              <Typography color="text.secondary">Nenhum anexo selecionado.</Typography>
                            )}
                          </ContainerForm>

                        )}
                    </>
                  )}
                </Box>

                <Box sx={{ justifySelf: 'center', padding: '32px' }}>
                  <Button
                    variant='text'
                    onClick={handleBack}
                    sx={{
                      fontFamily: 'Roboto',
                      fontSize: '14px',
                      textAlign: 'left',
                      fontWeight: 500,
                      color: '#0048B6',
                      lineHeight: '24px',
                      letterSpacing: '0.4px',
                      marginRight: '20px',
                    }}
                  >
                    VOLTAR
                  </Button>
                  <Button
                    variant='contained'
                    type='submit'
                    disabled={isSubmitting}
                    onClick={(e) => {
                      console.log('🔴 Botão AVANÇAR clicado', {
                        activeStep,
                        isSubmitting,
                        errors,
                        touched,
                        values: {
                          personalData: values.personalData,
                          loginData: values.loginData
                        }
                      });

                      // Verificar imediatamente se há erros de validação
                      if (Object.keys(errors).length > 0) {
                        console.error('❌ Erros de validação detectados:', errors);

                        // Encontrar o primeiro erro e dar feedback ao usuário
                        const firstError = Object.entries(errors).find(([, value]) => {
                          if (typeof value === 'object' && value !== null) {
                            return Object.keys(value).length > 0;
                          }
                          return !!value;
                        });

                        if (firstError) {
                          const [section, sectionErrors] = firstError;
                          console.error(`Erro na seção ${section}:`, sectionErrors);

                          if (typeof sectionErrors === 'object' && sectionErrors !== null) {
                            const firstFieldError = Object.values(sectionErrors)[0] as string;
                            const errorMsg = firstFieldError || 'Por favor, preencha todos os campos obrigatórios corretamente.';
                            console.error('Mensagem de erro:', errorMsg);
                            setErrorMessage(errorMsg);
                            setTimeout(() => setErrorMessage(''), 8000);
                          }
                        }
                      } else {
                        console.log('✅ Nenhum erro de validação detectado');
                      }
                    }}
                    sx={{
                      fontFamily: 'Roboto',
                      fontSize: '14px',
                      fontWeight: 500,
                      lineHeight: '24px',
                      textAlign: 'left',
                      background: '#0048B6',
                      letterSpacing: '0.4px',
                    }}
                  >
                    {activeStep === 1 ? 'AVANÇAR' : 'CONFIRMAR E SALVAR'}
                  </Button>
                </Box>
              </form>
            );
          }}
        </Formik>
      </Box>


      <Box sx={{ width: '1200px' }}>
        <DynamicDialog
          isOpen={isDialogOpen}
          icon={
            userFormAction === UserFormAction.CADASTRAR
              ? RegisteredIcon
              : UpdatedIcon
          }
          title={
            userFormAction === UserFormAction.CADASTRAR
              ? 'Usuário Cadastrado'
              : 'Usuário Alterado'
          }
          message={successMessage}
          buttonText='Concluir'
          onClose={() => setIsDialogOpen(false)}
          routeOnClose={ROUTES.LOGIN}
        />
      </Box>

      {errorMessage && (
        <SnackbarFeedback
          isOpen={!!errorMessage}
          message={errorMessage}
          type='error'
        />
      )}

      <ErrorDialog
        open={invalidRequest}
        title='Ocorreu um erro na sua solicitação'
        message1='Deseja atualizar a página atual?'
        button1Text='FECHAR'
        button1Action={() => setInvalidRequest(false)}
        button1Color='inherit'
        button2Text='ATUALIZAR'
        button2Action={handleRefresh}
        button2Color='primary'
      />
    </ContainerPainel>
  );
};

export default UserFormCreate;

// Re-export pure helpers for unit tests (no runtime behavior change)
// Export internal pure functions for unit testing
export const construirUserDataCreatePure = (...args: any[]) => (_construirUserDataCreatePure as any)(...args);
export const validarDadosCreatePure = (...args: any[]) => (_validarDadosCreatePure as any)(...args);
export const processarArquivoCreateHelper = (...args: any[]) => (_processarArquivoCreateHelper as any)(...args);
export const gerarDadosAtualizadosCreatePure = (...args: any[]) => (_gerarDadosAtualizadosCreatePure as any)(...args);
export const verificarAlteracaoDeVigenciaPure = (...args: any[]) => (_verificarAlteracaoDeVigenciaPure as any)(...args);
export const getNameByUuidCreate = (...args: any[]) => (_getNameByUuidCreate as any)(...args);
export const getTipoRepresentanteCreate = (...args: any[]) => (_getTipoRepresentanteCreate as any)(...args);
